<script>
  export default {
    name: 'kye-field',
    props: {
      value: [String, Number]
    },
    mounted () {
      this.$el.addEventListener('copy', this.handleCopy)
    },
    beforeDestroy () {
      this.$el.removeEventListener('copy', this.handleCopy)
    },
    methods: {
      // 浏览器升级后，双击文本框未选中文本区域，解决方案：增加一个不可见字符，定义容器边界
      handleCopy (e) {
        let text = window.getSelection().toString()
        if (text && text.includes('\u200B')) {
          // 弹窗情况会导致window.getSelection()获取的文本不准确
          const dom = this.$el
          dom.setAttribute('contentEditable', true)
          text = window.getSelection().toString()
          dom.removeAttribute('contentEditable')
          text = text.replace(/\u200B/g, '')
          e.clipboardData.setData('text/plain', text)
          e.preventDefault()// 阻止默认复制行为
        }
      }
    },
    render (h) {
      let title = this.$slots && this.$slots.default && this.$slots.default[0] && this.$slots.default[0].text
      title = this.value || title || ''
      if (title && typeof title === 'string') {
        title = title.trim()
      }
      return (
        <span class="kye-field-content" title={ title }>
          <label>{ this.value !== undefined ? this.value : this.$slots.default }</label>&#8203;
        </span>
      )
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/kye-field/index.vue